// DiscoverMapListSkeleton.jsx
import "./discoverMapPageSkeleton.css";

const SkeletonItem = () => (
	<div className="discover-map-list-item skeleton-card">
		<div className="skeleton-image shimmer" />
		<div className="skeleton-info">
			<div className="skeleton-line title shimmer" />
			<div className="skeleton-line rating shimmer" />
		</div>
		<div className="skeleton-line location shimmer" />
	</div>
);

const DiscoverMapListSkeleton = ({ count = 6 }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, i) => (
				<SkeletonItem key={i} />
			))}
		</>
	);
};

export default DiscoverMapListSkeleton;
